'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const utils_createUniqueCustomProperty = require('../../../utils/createUniqueCustomProperty.cjs.js');

const Vars = utils_createUniqueCustomProperty.createUniqueCustomProperties("Table", [
  "frozenCellHorzShadowOpacity",
  "frozenCellVertShadowOpacity"
]);

exports.Vars = Vars;
//# sourceMappingURL=Vars.cjs.js.map
